import { createContext, useContext, useEffect, useState, useSyncExternalStore, type ReactNode } from 'react';
import { useSettings } from '../lib/settings';
import { StudioEngine } from './engine';

const Ctx = createContext<StudioEngine | null>(null);

/** One studio engine for the whole visit, so the live state survives moving between pages. */
export function StudioProvider({ children }: { children: ReactNode }) {
  const { s } = useSettings();
  const [engine] = useState(() => new StudioEngine(s));
  // a handle for debugging in development
  if (import.meta.env.DEV && typeof window !== 'undefined') (window as unknown as { __studio: StudioEngine }).__studio = engine;
  useEffect(() => { engine.applySettings(s); }, [engine, s]);
  return <Ctx.Provider value={engine}>{children}</Ctx.Provider>;
}

/** The engine, re-rendering on every change it reports. */
export function useStudio(): StudioEngine {
  const e = useContext(Ctx);
  if (!e) throw new Error('useStudio outside StudioProvider');
  useSyncExternalStore(e.subscribe, e.getVersion);
  return e;
}
/** The engine without subscribing to its changes. */
export function useEngine(): StudioEngine {
  const e = useContext(Ctx);
  if (!e) throw new Error('useEngine outside StudioProvider');
  return e;
}
